import { render, staticRenderFns } from "./createWave.vue?vue&type=template&id=32a8a5d0&"
import script from "./createWave.vue?vue&type=script&lang=js&"
export * from "./createWave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports